module.exports = __webpack_public_path__ + "static/img/service_introduce_5115_zh_h5.855d486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5115_zh_h5.png
// module id = PotG
// module chunks = 34